// Dependencies
import { FC } from "react";

// Styles
import { StyledErrorMessage } from "./FormErrorMessage.styled";

interface FormErrorMessageProps {
  hasError: boolean;
  error: string | undefined;
}

const FormErrorMessage: FC<FormErrorMessageProps> = ({ hasError, error }) => {
  if (hasError) {
    return (
      <StyledErrorMessage variant={"h5"}>
        {hasError && error}
      </StyledErrorMessage>
    );
  } else return null;
};

export default FormErrorMessage;
